<app-modal title="Delete Capabilities" #modalComponent>

  <div class="ms-3 delete-text">
    Delete capabilities starting from:
  </div>

  <form (ngSubmit)="confirm(modalComponent)" #f="ngForm" class="p-3" autocomplete="off">

    <app-input-date
            [placeholder]="'Start date'"
            [name]="'startDate'"
            [(inputDate)]="startDate"
            [editDate]="editDate"
            [onlyMondays]="true">
    </app-input-date>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!f.valid || !startDate || loading">Save
      </button>
    </div>
  </form>
</app-modal>